<template>

  <div class="all">
    <headercon></headercon>
    <div class="content">
      <el-carousel arrow="always"
                   class="ban"
                   trigger="click"
                   indicator-position="none"
                   ref="car"
                   :interval="50000">
        <el-carousel-item v-for="(item, i) in goodsList"
                          :key="i">
          <div class="box">
            <img :src="item.image"
                 alt=""
                 class="img">
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import son from './son'
import headercon from './header'
// eslint-disable-next-line no-unused-vars
import { Carousel, CarouselItem } from 'element-ui'
export default {
  components: {
    son,
    headercon
  },
  data () {
    return {
      goodsList: [],
      pageNum: 0,
      pageSize: 10000
    }
  },
  created () {
    this.setData()
  },
  methods: {
    getlist () {
      const that = this
      const url = that.HOST + '/openApi/productList'
      let arr2 = []
      axios.get(url, { params: { prodId: that.prodId, pageNum: this.pageNum, pageSize: this.pageSize } })
        .then(function (response) {
          let arr = response.data.rows
          for (let i = 0; i < arr.length; i++) {
            arr2.push(arr[i])
          }
          // console.log(arr2)

          if (arr.length !== 0) {
            that.goodsList = []
            for (let a = 0; a < arr2.length; a++) {
              that.goodsList.push(arr2[a])
            }
            console.log(that.goodsList)
          }
        })
        .catch(function (error) {
          console.log('11111111111' + error)
        })
    },
    setData () {
      this.pageNum = this.pageNum + 1
      this.prodId = this.$route.params.prodId
      this.getlist(this.$route.params.prodId, this.pageNum)
    }
  }
}
</script>

<style scoped lang="less">
.all {
  background: url("../assets/details.png");
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  min-width: 1199px;
  /deep/ .li2 {
    list-style-type: none;
    float: left;
    border-radius: 25px;
    background: #fff;
    width: 100px;
    height: 30px;
    text-decoration: none;
    text-align: center;
    line-height: 30px;
    a {
      color: #757575;
      text-decoration: none;
    }
  }
  .content {
    width: 100%;
    height: 70%;
    margin: 3% auto;
    .box {
      width: 90%;
      height: 100%;
      margin: 0 auto;
      justify-content: space-between;
      display: flex;
      .img {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product.vue